import React from "react";

import FormChangeEmail from "../../components/Forms/ChangeEmail/ChangeEmail";

function ChangeEmail() {
  return <FormChangeEmail />;
}

export default ChangeEmail;
